export default __webpack_public_path__ + "static/media/card_3@2x.ff971991.png";